var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEgfr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.07875 21.9952014 0.07875 21.9952014 17.9999839 0 17.9999839"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ADPKD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Prognostic-Tools-Option-1",
    transform: "translate(-263.000000, -514.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(263.000000, 514.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0912884,16.1774839 L18.0782449,16.1774839 L16.2704986,16.1774839 L12.6547667,16.1774839 L10.8469406,16.1774839 L7.23128841,16.1774839 L5.42346232,16.1774839 L1.80781014,16.1774839 L1.80781014,0.989983929 C1.80781014,0.486948214 1.40288261,0.0787339286 0.903897101,0.0787339286 C0.404911594,0.0787339286 -1.5942029e-05,0.486948214 -1.5942029e-05,0.989983929 L-1.5942029e-05,17.0887339 C-1.5942029e-05,17.59185 0.404911594,17.9999839 0.903897101,17.9999839 L21.0912884,17.9999839 C21.5903536,17.9999839 21.9952014,17.59185 21.9952014,17.0887339 C21.9952014,16.5856982 21.5903536,16.1774839 21.0912884,16.1774839",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.9056366,1.00031378 C4.41908652,0.987174286 4.01405553,1.38833429 4.00030064,1.89607015 C3.98771141,2.40388713 4.37207122,2.82670296 4.8586213,2.83984245 C5.19930739,2.85882171 12.9423001,3.41343798 17.45981,11.7560412 L15.4505859,11.3297377 C14.9778684,11.2375179 14.5223251,11.5595977 14.4270511,12.0518419 C14.3306892,12.5440862 14.6313539,13.0243264 15.1018178,13.1321189 L19.1316897,13.9811571 C19.3612487,14.0303085 19.5987342,13.9823737 19.7938672,13.8482211 C19.9889224,13.7129331 20.125461,13.5033501 20.1713107,13.2638382 L20.9848697,9.05774134 C21.0732273,8.56436158 20.765724,8.08769007 20.2940944,7.9882517 C19.8225426,7.88889444 19.3612487,8.20262006 19.2579704,8.69243106 L18.8792836,10.6421855 C13.8614687,1.61349 5.3314165,1.0218885 4.95265191,1.00031378 L4.9056366,1.00031378 Z",
    id: "Fill-4",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEgfr);
export default __webpack_public_path__ + "static/media/icon-egfr.c00b39e7a597dcbb0109028d66808c43.svg";
export { ForwardRef as ReactComponent };